import {
  FREE_DELIVERY_FROM_PRICE_LANDELIJK,
  FREE_DELIVERY_FROM_PRICE_STANDARD,
  FREE_DELIVERY_FROM_PRICE_WEST_FRIESLAND,
  ZIPCODES_ENKHUIZEN,
  ZIPCODES_STEDE_BROEC,
  ZIPCODES_WEST_FRIESLAND,
} from "../constants/DeliveryConstants";

export const parseZipPrefix = (zip) => {
  if (!zip) return null;
  const match = String(zip).match(/\d{4}/);
  return match ? parseInt(match[0], 10) : null;
};

export const isLandelijk = (zip) => {
  const prefix = parseZipPrefix(zip);
  if (!prefix) return true; // treat unknown as landelijk until specified
  const localZips = new Set([
    ...ZIPCODES_ENKHUIZEN,
    ...ZIPCODES_STEDE_BROEC,
    ...ZIPCODES_WEST_FRIESLAND,
  ]);
  return !localZips.has(prefix);
};

export const effectiveFrozenForZip = (productFrozen, zip) => {
  const prefix = parseZipPrefix(zip);
  if (!prefix) return null; // unknown yet => do not show tags
  return isLandelijk(prefix) ? true : !!productFrozen;
};

/**
 * Returns true when the zip code belongs to Enkhuizen or Stede Broec.
 * Accepts full zip strings like "1601 AB" or just the 4-digit prefix.
 */
export const isEnkhuizenOrStedeBroec = (zip) => {
  const prefix = parseZipPrefix(zip);
  if (!prefix) return false;
  const local = new Set([...ZIPCODES_ENKHUIZEN, ...ZIPCODES_STEDE_BROEC]);
  return local.has(prefix);
};

/**
 * Returns the free delivery threshold amount (number) based on the given zip code.
 * Logic:
 *  - Landelijk => FREE_DELIVERY_FROM_PRICE_LANDELIJK
 *  - Enkhuizen/Stede Broec => FREE_DELIVERY_FROM_PRICE_STANDARD
 *  - West-Friesland => FREE_DELIVERY_FROM_PRICE_WEST_FRIESLAND
 * Falls back to STANDARD for any other known local zip.
 */
export const getFreeDeliveryFromPrice = (zip) => {
  if (isLandelijk(zip)) return FREE_DELIVERY_FROM_PRICE_LANDELIJK;
  const prefix = parseZipPrefix(zip);
  if (!prefix) return FREE_DELIVERY_FROM_PRICE_LANDELIJK; // default until provided
  if (isEnkhuizenOrStedeBroec(prefix)) return FREE_DELIVERY_FROM_PRICE_STANDARD;
  if (new Set(ZIPCODES_WEST_FRIESLAND).has(prefix))
    return FREE_DELIVERY_FROM_PRICE_WEST_FRIESLAND;
  // Any other non-landelijk local zip falls back to STANDARD
  return FREE_DELIVERY_FROM_PRICE_STANDARD;
};
